export const VUUR = 'AIzaSyDVCZcIq42m_zMxheQ7gXoFFANKdmG-L1g';

export const firebaseConfig = {
    apiKey: "AIzaSyDVCZcIq42m_zMxheQ7gXoFFANKdmG-L1g",
    authDomain: "showtime-201ca.firebaseapp.com",
    databaseURL: "https://showtime-201ca.firebaseio.com",
    projectId: "showtime-201ca",
    storageBucket: "showtime-201ca.appspot.com",
    messagingSenderId: "832449882720",
    appId: "1:832449882720:web:4aa874e678615a2b077105"
};

export const createSuperSecurePassword = (user) => {
    const number = Math.floor(Math.random() * 100);
    return user.firstName + number;
};